<template>
	<div class="spinner">
		<svg class="spinner__svg" viewBox="25 25 50 50">
			<circle
				class="spinner__circle"
				cx="50"
				cy="50"
				r="23.5"
				:stroke="stroke"
				:stroke-width="strokeWidth"
				fill="none"
				fill-rule="evenodd"
			/>
		</svg>
	</div>
</template>

<script>
/**/
export default {
	props: {
		stroke: {
			type: String,
			default: '#000',
		},
		strokeWidth: {
			type: Number,
			default: 1.5,
		},
	},
};
</script>

<style lang="scss" scoped>
.spinner {
	position: absolute;
	z-index: 100;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 3rem;
	height: 3rem;
	transition: opacity 0.4s;
}

.spinner__svg {
	transform-origin: center center;
	animation: rotate 2s linear infinite;
}

@keyframes rotate {
	100% {
		transform: rotate(1turn);
	}
}

.spinner__circle {
	stroke-dasharray: 1, 200;
	stroke-dashoffset: 0;
	stroke-linecap: round;
	animation: dash 1.5s ease-in-out infinite;
}

@keyframes dash {
	0% {
		stroke-dasharray: 1, 200;
		stroke-dashoffset: 0;
	}
	50% {
		stroke-dasharray: 89, 200;
		stroke-dashoffset: -35px;
	}
	100% {
		stroke-dasharray: 89, 200;
		stroke-dashoffset: -124px;
	}
}
</style>
